import React from "react";
import Wrapper from "./components/Wrapper";
import Title from "./components/Title";
import Directory from "./components/Directory";

function App () {
    return (
      <Wrapper>
        <Title />
        <Directory />
      </Wrapper>
    )
}

export default App;










